import { render, staticRenderFns } from "./ApplySettingsBtn.vue?vue&type=template&id=2a0416b4&scoped=true"
import script from "./ApplySettingsBtn.vue?vue&type=script&lang=js"
export * from "./ApplySettingsBtn.vue?vue&type=script&lang=js"
import style0 from "./ApplySettingsBtn.vue?vue&type=style&index=0&id=2a0416b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0416b4",
  null
  
)

export default component.exports